import { ContentBlock } from 'interfaces/microsite-cms';

export function setBlocksPropsFromAttributes(attributes: ContentBlock['attributes']) {
    return attributes && Object.fromEntries(attributes.map((item: any) => [item.name, item.value]));
}

export function setGlideSelector(selector: string | HTMLDivElement | null) {
    return selector || '.glide';
}

export function updateGlideTabindex() {
    const anchorElements = document.querySelectorAll('.glide__slide a');
    anchorElements.forEach((anchor) => {
        const closestSlide = anchor.closest('.glide__slide');
        if (closestSlide && closestSlide.classList.contains('glide__slide--active')) {
            anchor.setAttribute('tabindex', '');
        } else {
            anchor.setAttribute('tabindex', '-1');
        }
    });
}
